import {environment} from '../../../../apps/frontend/src/environments/environment'
import {Injectable} from '@angular/core'
import {HttpClient, HttpHeaders} from '@angular/common/http'
import {map, Observable, of} from 'rxjs'


@Injectable({
  providedIn: 'root',
})
export class ReportService {

  constructor(
      private readonly http: HttpClient,
  ) {
  }


  fetchDriverPdf(): Observable<Blob> {
    const url = `${environment.apiUrl}/reports/drivers`
    const headers = new HttpHeaders({
      Accept: 'application/pdf', // Specify that we accept a PDF response
    })

    return this.http.get(url, {
      headers: headers,
      responseType: 'blob',
    }).pipe(
        map(values => {
          return values
        }),
    )
  }


  getEventsPdf(eventIds: number[], detailed: boolean = false, startDate?: string, endDate?: string): Observable<Blob> {
    const url = `${environment.apiUrl}/reports/events?detailed=${detailed}&startDate=${startDate}&endDate=${endDate}`
    const headers = new HttpHeaders({
      Accept: 'application/pdf', // Specify that we accept a PDF response
    })

    return this.http.post(url, eventIds, {
      headers: headers,
      responseType: 'blob',
    }).pipe(
        map(values => {
          return values
        }),
    )
  }


  getEventReceiptPdf(eventId: number): Observable<Blob> {
    const url = `${environment.apiUrl}/reports/receipts/${eventId}`
    const headers = new HttpHeaders({
      Accept: 'application/pdf', // Specify that we accept a PDF response
    })

    return this.http.get(url, {
      headers: headers,
      responseType: 'blob',
    }).pipe(
        map(values => {
          return values
        }),
    )
  }


  sendReceipt(eventId: number, emailAddressId?: number): Observable<number> {
    // TODO: display message on unknown email
    if (!emailAddressId) {
      return of(0)
    }
    const url = `${environment.apiUrl}/reports/receipts/${eventId}?emailId=${emailAddressId}`
    return this.http.get<number>(url).pipe(
        map(value => {
          return value
        }),
    )
  }


  fetchPaymentsPdf(year: number, month: number, driverUserId: number): Observable<Blob> {
    const url = `${environment.apiUrl}/drivers/payments/${year}/${month}?${driverUserId}`
    const headers = new HttpHeaders({
      Accept: 'application/pdf', // Specify that we accept a PDF response
    })

    return this.http.get(url, {
      headers: headers,
      responseType: 'blob',
    }).pipe(
        map(values => {
          return values
        }),
    )
  }
}
